import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';
import { useDevice } from 'app/agriculture/queries/devices/useDevice';
import { useMemo } from 'react';
import { StatusMessage } from 'app/agriculture/routes/Devices/utils/status/types';
import { checkTankSensor } from 'app/agriculture/routes/Devices/utils/status/tankSensorStatus/checkTankSensor';
import { validateLevelSnapshot } from 'app/agriculture/routes/Devices/utils/validateLevelSnapshot';
import { brandConfig } from 'app/agriculture/queries/snapshots/config/brandConfig';

export function useTankSensorStatus({ deviceId }: { deviceId: string }): StatusMessage {
    const device = useDevice({ deviceId });

    const levelSnapshot = useSnapshot({
        parentId: deviceId,
        snapshotType: brandConfig[device.brand].levelSnapshotType,
        shelfLife: brandConfig[device.brand].snapshotShelfLife,
    });

    const validatedLevelSnapshot = validateLevelSnapshot(levelSnapshot, { device });

    return useMemo(
        () => checkTankSensor({ device, snapshots: { Level: validatedLevelSnapshot } }),
        [device, validatedLevelSnapshot],
    );
}
